import { BiTimeFive } from 'react-icons/bi';

import type { TaskResponse } from '@/store/tasks/tasks.dto';

import s from './TaskExpiringLabel.module.scss';

export const TaskExpiredLabel = ({
  task,
  extended,
}: {
  task: TaskResponse;
  extended?: boolean;
}) => (
  <p className={s.overdue} title={getOverdueLabel(task.time_slot.end)}>
    <BiTimeFive color="#EF4444" size={24} />
    {extended && getOverdueLabel(task.time_slot.end)}
  </p>
);

const getOverdueLabel = (deadline: string) => {
  const now = new Date();
  const end = new Date(deadline);

  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);

  const diffMs = now.getTime() - end.getTime();
  const diffDays = Math.max(Math.floor(diffMs / (1000 * 60 * 60 * 24)), 1);

  if (end >= startOfToday) {
    return `Till ${end.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })} today`;
  }

  if (diffDays === 1) {
    return 'Overdue by 1 day';
  }

  return `Overdue by ${diffDays} days`;
};
